var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ci-content-hub-navigation bg-white",
      class: { "mr-3 p-4": !_vm.mobileMode },
    },
    [
      !_vm.mobileMode
        ? _c("div", { staticClass: "ci-content-hub-navigation--desktop" }, [
            _c("h3", {
              staticClass: "h3",
              domProps: {
                textContent: _vm._s(
                  _vm.$t("ui.components.content_hubs.navigation.header")
                ),
              },
            }),
            _c(
              "div",
              { staticClass: "mt-3" },
              _vm._l(_vm.contentRoutes, function (route) {
                return _c("content-hub-nav-item", {
                  key: route.slug,
                  attrs: { "nav-item": route },
                })
              }),
              1
            ),
          ])
        : _c(
            "div",
            {
              staticClass: "ci-content-hub-navigation--mobile w-100 h-100",
              class: { expanded: _vm.expanded },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "expand-element m-0 w-100 bg-primary text-center text-white p-2 font-weight-semi",
                  on: { click: _vm.toggleMobileMenu },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("ui.components.content_hubs.navigation.header")
                      ),
                    },
                  }),
                  _c("div", { staticClass: "mdi mdi-24px mdi-chevron-up" }),
                ]
              ),
              _c(
                "div",
                { staticClass: "menu d-flex bg-white w-100" },
                _vm._l(_vm.contentRoutes, function (route, index) {
                  return _c("content-hub-nav-item", {
                    key: index,
                    attrs: { "nav-item": route },
                  })
                }),
                1
              ),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }